<template>
  <header class="header" id="header">
    <div class="table">
      <div class="tr">
        <div class="td align-middle">
          <router-link to="/" class="logo">
            <img src="@/assets/frontstage/images/logo.png" alt="logo">
            <div class="table">
              <div class="tr">
                <div class="td">
                  蘭陽地區
                </div>
              </div>
              <div class="tr">
                <div class="td">
                  林業文化歷史資料庫
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="td align-middle align-right">
          <button class="menu-mobile-btn" @click="openMobileNav()"><i class="fas fa-bars"></i></button>
          <div :class="menu">
            <div class="subnav">
              <ul class="align-right">
                <li>
                  <a accesskey="U" href="#top" title="menu" class="accesskey-top">:::</a>
                  <router-link to="/">首頁</router-link>
                  <router-link to="/about">關於本站</router-link>
                  <router-link to="/sitemap">網站導覽</router-link>
                  <router-link to="/faq">常見問題</router-link>
                  <router-link to="/contact">聯絡我們</router-link>
                </li>
              </ul>
            </div>
            <nav class="nav">
              <ul class="align-right">
                <li>
                  <router-link to="/themes"><i class="fas fa-book"></i>主題專區</router-link>
                  <router-link to="/news"><i class="far fa-newspaper"></i>最新消息</router-link>
                  <router-link to="/recommended"><i class="fas fa-thumbs-up"></i>本日精選</router-link>
                  <router-link to="/collection"><i class="fas fa-landmark"></i>館藏資源</router-link>
                </li>
              </ul>
            </nav>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'Header',
    data (){
      return {
        stateMobileNav: false,
        menu: 'menu',
      }
    },
    methods: {
      openMobileNav() {
        let self = this;
        if (self.menu=='menu is-open') {
          self.menu = 'menu'
        }
        else {
          self.menu = 'menu is-open'
        }
      }
    },
    created () {
      let self = this;
      self.resize = _.debounce(function () {
        self.menu = 'menu'
      })
    },
    mounted () {
      let self = this;
      window.addEventListener('resize', function(){
        self.menu = 'menu'
      })
    },
    beforeDestroy () {
      let self = this;
      window.removeEventListener('resize', function(){
        self.menu = 'menu'
      })
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.accesskey-top{
    color: #3eb179 !important;
  }
</style>
